import React, {ReactElement} from 'react';
import MComponent from '../../Toolkit/Components/Component';

type Props = {
    size: number;
    status: number;
    onClick?: () => void;
    notRequired?: boolean;
}

class StatusIndicator extends MComponent<Props> {

    public constructor(props: Props) {
        super(props);

        this.bindMethods();
    }

    private bindMethods(): void {
        this.onClick = this.onClick.bind(this);
    }

    private onClick(event: React.MouseEvent<HTMLElement>) : void {
        if(this.props.onClick !== undefined) {
            this.props.onClick();
        }
    }

    public render(): ReactElement {
        const radius = (this.props.size - 2) / 2;
        const centre = this.props.size / 2;
        const notRequired = this.props.notRequired ?? false;

        let colour;

        if(notRequired) {
            colour = 'dimgrey'
        } else {
            switch(this.props.status) {
                case 1:
                    colour = 'red';
                    break;
                case 2:
                    colour = 'limegreen';
                    break;
                case 6:
                    colour = 'yellow'
                    break;
                default:
                    colour = 'red';
            }
        };

        return (
            <div style={{margin: 'auto'}} onClick={this.onClick}>
                <svg width={this.props.size}
                     height={this.props.size}
                     style={{display: 'block', margin: 'auto'}}>
                    <circle cx={centre}
                            cy={centre}
                            r={radius}
                            stroke="black"
                            strokeWidth="1"
                            fill={colour}/>
                </svg>
            </div>
        );
    }
}

export default StatusIndicator;